import { DictionaryItem } from "@sa/rep-mdm";
import { getDateParts } from "./dateHelpers";

const [weekFrequency] = [7];

export function getCalendarParameterSelection(selection: number[], calendarOriginItems: DictionaryItem[]) {
  let result = new Set(selection);

  const scan = (id: number) => {
    const item = calendarOriginItems.find((item) => Number(item.id) === id);

    if (item != null) {
      const parent = item.getValue<number>("parent");

      if (parent != null) {
        result.add(parent);

        const { frequency } = getDateParts(parent);
        if (Number(frequency) < weekFrequency) {
          scan(parent);
        }
      }
    }
  };

  for (let i = 0; i < selection.length; i++) {
    scan(selection[i]);
  }

  return [...result];
}
